module.exports = __webpack_public_path__ + "static/images/callout_2.8d7c5e6abc49be33663556411485792e.jpg";